// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as RowsBDefault } from '../../../assets/icons/default/layout/rows-b.svg?react';
import { ReactComponent as RowsBSolid } from '../../../assets/icons/solid/layout/ROWS-B.svg?react';
import { createIcons } from '../../Icon';
const RowsBIcon = /* @__PURE__ */ createIcons('RowsB', {
    default: RowsBDefault,
    solid: RowsBSolid
});
RowsBIcon.supportedTypes = ['default', 'solid'];
RowsBIcon.category = 'layout';
export default RowsBIcon;
